"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EssentialTipsTabs = void 0;
var react_1 = __importDefault(require("react"));
var BuyRentSVG_1 = __importDefault(require("../components/Icons/EssentialTips/BuyRentSVG"));
var BuyRentSpecialistSVG_1 = __importDefault(require("../components/Icons/EssentialTips/BuyRentSpecialistSVG"));
var SellRentOwnSVG_1 = __importDefault(require("../components/Icons/EssentialTips/SellRentOwnSVG"));
var SellRentSpecialistSVG_1 = __importDefault(require("../components/Icons/EssentialTips/SellRentSpecialistSVG"));
exports.EssentialTipsTabs = [
    {
        id: 1,
        name: 'buy_rent',
        path: '/buy_rent',
        icon: react_1.default.createElement(BuyRentSVG_1.default, null),
        translationText: 'ESSENTIAL_TIPS.TAB_STEPS.FIRST_TAB',
    },
    {
        id: 2,
        name: 'buy_rent_specialist',
        path: '/buy_rent_specialist',
        icon: react_1.default.createElement(BuyRentSpecialistSVG_1.default, null),
        translationText: 'ESSENTIAL_TIPS.TAB_STEPS.SECOND_TAB',
    },
    {
        id: 3,
        name: 'sell',
        path: '/sell',
        icon: react_1.default.createElement(SellRentOwnSVG_1.default, null),
        translationText: 'ESSENTIAL_TIPS.TAB_STEPS.THIRD_TAB',
    },
    {
        id: 4,
        name: 'sell_specialist',
        path: '/sell_specialist',
        icon: react_1.default.createElement(SellRentSpecialistSVG_1.default, null),
        translationText: 'ESSENTIAL_TIPS.TAB_STEPS.FOURTH_TAB',
    },
];
